import React, { useState, useEffect } from "react";
//import "./styles.css";
//import { Container, Row, Col, Modal, Button, Form, Dropdown, Table } from 'react-bootstrap';
// import LeftpanelAdmin from "../../../components/leftpanel/left-panel-admin";
// import HeaderPart from "../../../components/layout/header-admin/header";
//import "../user-details.css";
import { Row, Col, Form } from "react-bootstrap";
// import {
//     AddIcon,
//     DeleteIcon,
// } from "../../../assets/images";
import axios from "../../../axios/axios";
import { message } from "antd";
import LoadingOverlay from "react-loading-overlay";
import { adminConfig } from "../../../utils/adminConfig";

const VilocityCommissionSet = () => {
  const [loading, setLoading] = useState(false);
  const [commission, setCommission] = useState(0);

  const getCommission = async () => {
    await axios
      .get(`/velocity-commission-data`, adminConfig())
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          setCommission(res.data.data.commission);
        } else {
          message.error("failed fetching member");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const updateCommission = async () => {
    if (commission != "" && commission >= 0) {
      let data = {
        amount: commission,
      };
      await axios
        .post(`/vilocity-commission-update`, data, adminConfig())
        .then((res) => {
          setLoading(false);
          if (res.data.status) {
            message.success("update successfully!");
            getCommission();
          } else {
            message.error("failed");
          }
        })
        .catch((err) => {
          setLoading(false);

          console.log(err);
        });
    } else {
      message.error("Please enter correct amount");
    }
  };

  useEffect(() => {
    getCommission();
  }, []);

  return (
    // <div>
    //     <HeaderPart />
    //     <div className='main_cont'>
    //         <LeftpanelAdmin />

    <LoadingOverlay active={loading} spinner text="Loading ...">
      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <div className="text_field_partts">
              <div className="user_added">
                <div className="d-flex justify-content-between w-100">
                  <h2>Vilocity Commission Settings</h2>
                </div>
                <Row>
                  <Col lg="6" md="6" sm="6">
                    <h5>Enter Vilocity Commission Amount ($)</h5>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Control
                        type="number"
                        name="commission"
                        min={0}
                        step={1}
                        placeholder="Enter Vilocity Commission Amount"
                        className="text_link"
                        value={commission}
                        onChange={(event) => {
                          setCommission(event.target.value);

                          // setCommission(event.target.value)
                        }}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg="6" md="6" sm="6">
                    <Form.Group className="mt-4" controlId="formBasicEmail">
                      <button
                        type="button"
                        onClick={updateCommission}
                        className="add_but submit_buttt mt-0"
                      >
                        Update Commission
                      </button>
                    </Form.Group>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoadingOverlay>
    //     </div>
    // </div>
  );
};
const CustomLoader = () => (
  <div
    style={{
      padding: "15px",
      background: "#495A71",
      color: "#fff",
      width: "100%",
      fontSize: "40px",
      textAlign: "center",
      minHeight: "350px",
      lineHeight: "400px",
    }}
  >
    <div>Loading...</div>
  </div>
);
const EmptyDataLoader = () => (
  <div
    style={{
      padding: "15px",
      background: "#495A71",
      color: "#fff",
      width: "100%",
      fontSize: "40px",
      textAlign: "center",
      minHeight: "350px",
      lineHeight: "400px",
    }}
  >
    <div>No data found...</div>
  </div>
);

export default VilocityCommissionSet;
